import { render, staticRenderFns } from "./AccountScalingSpecs.vue?vue&type=template&id=1d77885d&"
import script from "./AccountScalingSpecs.vue?vue&type=script&lang=js&"
export * from "./AccountScalingSpecs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports